import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
} from "@fluentui/react-components";
import React from "react";
import ASCButton from "../Button";

function SystemManagerDeletePopup(props: any) {
  return (
    <Dialog open={props.deletePopup}>
      <DialogSurface>
        <DialogBody>
          <h3>Do you want to delete?</h3>
          <DialogActions>
            <ASCButton
              shape="rounded"
              appearance="primary"
              className="asc-button-primary"
              onClick={() => props.setDeletePopup(false)}
              label="No"
            />
            <ASCButton
              shape="rounded"
              appearance="secondary"
              onClick={() => props.deleteData()}
              label="Yes"
            />
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export default SystemManagerDeletePopup;
